module.exports = __webpack_public_path__ + "img/icon_nav_home_hover.e0afb3bf.svg";